export default "__VITE_ASSET__C_17JpC3__"